import { createApi } from '@reduxjs/toolkit/query/react';

import Resource from '@guestyci/agni';

import { USE_OWNERS_HYDRA } from 'constants/featureToggle';

let cachedApi = null;
let cachedFT = window.featureToggle?.isEnabled(USE_OWNERS_HYDRA);

const dynamicBaseQuery = async (args, api, extraOptions) => {
  const useOwnersHydra = window.featureToggle?.isEnabled(USE_OWNERS_HYDRA);

  if (!cachedApi || useOwnersHydra !== cachedFT) {
    cachedApi = Resource.create({
      domain: useOwnersHydra ? 'owners' : 'v2/owners',
      development: true,
    }).api;

    cachedFT = useOwnersHydra;
  }

  return cachedApi(args, api, extraOptions);
};

export const ownersApi = createApi({
  reducerPath: 'ownersApi',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['me'],
  endpoints: ({ mutation }) => ({
    putOwner: mutation({
      query: (data) => ({
        url: '/me',
        method: 'PUT',
        data,
        invalidatesTags: ['me'],
      }),
    }),
  }),
});

export const { usePutOwnerMutation } = ownersApi;
